import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { loginWithPassword } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await loginWithPassword(email, password);
      toast.success("Welcome back!");
      const next = params.get("redirect");
      const dest = next || (u.role === "vendor" ? "/vendor" : u.role === "admin" ? "/admin" : "/dashboard");
      navigate(dest, { replace: true });
    } catch (err) { toast.error(err?.response?.data?.detail || "Invalid credentials"); }
    setLoading(false);
  };

  return (
    <div className="min-h-[75vh] flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md rounded-3xl bg-card border border-border p-8 shadow-[0_10px_30px_-18px_rgba(31,42,68,0.25)]">
        <h1 className="font-display text-3xl font-semibold tracking-tight">Welcome back</h1>
        <p className="text-sm text-muted-foreground mt-1">Log in to continue your India journey.</p>

        <Button type="button" variant="secondary" className="mt-5 w-full rounded-xl h-11" onClick={googleLogin} data-testid="auth-google-button">
          <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24" fill="currentColor"><path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z"/></svg>
          Continue with Google
        </Button>

        <div className="flex items-center gap-3 my-5"><div className="h-px bg-border flex-1" /><span className="text-xs text-muted-foreground">or with email</span><div className="h-px bg-border flex-1" /></div>

        <form onSubmit={submit} className="grid gap-3">
          <label className="text-sm">Email
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="auth-email-input" />
          </label>
          <label className="text-sm">Password
            <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="auth-password-input" />
          </label>
          <Button type="submit" disabled={loading} className="rounded-xl h-11 mt-2" data-testid="auth-submit-button">{loading ? "Logging in…" : "Log in"}</Button>
        </form>

        <p className="mt-5 text-sm text-center">No account? <Link to="/auth/register" className="text-[hsl(var(--primary))] font-medium">Sign up</Link></p>
        <p className="mt-2 text-xs text-center text-muted-foreground">Try demo: tourist@demo.com / demo1234 · vendor@demo.com / demo1234</p>
      </div>
    </div>
  );
}
